// Custom components
import React, { useRef, useState } from "react";
import MiniCalendar from "components/calendar/MiniCalendar";

function DatePicker(props) {
  const {
    children,
    label,
    state,
    placeholder,
    value,
    onChange,
    isFutureDateDisabled,
    isPastDateDisabled,
    ...others
  } = props;
  const ref = useRef();

  const [isOpen, setIsOpen] = useState(false);

  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setIsOpen]);

  let className =
    "bg-[transparent] text-sm content-center dark:text-white select-none text-navy-700 rounded-3xl md:rounded-2xl px-2 py-1 border outline-none w-full md:min-w-[200px] h-10";
  if (state === "error") {
    className +=
      " border-red-500 dark:border-red-400 dark:text-red-400 invalid:!text-red-400";
  } else {
    className +=
      " border-gray-200 dark:border-gray-700 dark:text-white invalid:!text-gray-500";
  }

  return (
    <>
      <div className="flex-1 flex flex-col relative" ref={ref}>
        {label && (
          <label
            className="text-sm text-navy-700 dark:text-white ml-2 mb-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            {label}
          </label>
        )}
        <input
          className={className}
          onClick={() => setIsOpen(!isOpen)}
          value={value || ""}
          placeholder={placeholder}
          readOnly
        />
        <div className="absolute left-[0px] top-[100%] w-[340px] z-10">
          {isOpen && (
            <MiniCalendar
              isFutureDateDisabled={isFutureDateDisabled}
              isPastDateDisabled={isPastDateDisabled}
              value={value}
              onChange={(v) => {
                onChange && onChange(v);
                setIsOpen(false);
              }}
              {...others}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default DatePicker;
